<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="500"
      scrollable
      persistent
    >
      <PopupBannerForm
        :popup-banner="editedPopupBanner"
        :errors="popupBannerValidationErrors"
        :disabled="savingPopupBanner"
        @clear:errors="clearPopupBannerValidationErrors"
        @cancel="$router.push({ name: 'popupBanners', query: popupBannerFilterParams })"
        @save="onSave"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import PopupBannerForm from '../../components/PopupBannerForm';
import store from '../../store';

export default {
  name: 'EditPopupBanner',

  components: { PopupBannerForm },

  computed: mapState('popupBanners', [
    'editedPopupBanner',
    'popupBannerValidationErrors',
    'savingPopupBanner',
    'popupBannerFilterParams',
  ]),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('popupBanners/editPopupBanner', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'popupBanners' });
      });
  },

  methods: {
    ...mapActions('popupBanners', [
      'updatePopupBanner',
      'clearPopupBannerValidationErrors',
      'uploadPopupBannerImages',
      'deletePopupBannerImages',
    ]),
    ...mapMutations('popupBanners', ['SET_POPUP_BANNER_VALIDATION_ERRORS']),

    onSave(story) {
      this.updatePopupBanner(story).then(() => {
        this.$router.push({ name: 'popupBanners', query: this.popupBannerFilterParams });
      });
    },
  },
};
</script>
